"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeaturesFilterBar = void 0;
require("../css/features-filter-bar.scss");
var api_constants_1 = require("./constants/api-constants");
var constants_1 = require("./constants/constants");
var subcategories_filter_bar_1 = require("./subcategories-filter-bar");
var categories_menu_1 = require("./categories-menu");
var GenericFunctions = require("./generic-functions");
var filter_manager_1 = require("./filter-manager");
var brands_filter_bar_1 = require("./brands-filter-bar");
var queryString = require('query-string');
var features_filter_bar_mobile_1 = require("./features-filter-bar-mobile");
var FeaturesFilterBar = /** @class */ (function () {
    function FeaturesFilterBar() {
    }
    FeaturesFilterBar.init = function () {
        //events
        $(FeaturesFilterBar.featureListIdSelector + " li").off("click");
        $(FeaturesFilterBar.featureListIdSelector + " li").on("click", function (e) {
            FeaturesFilterBar.clickFeatureEvent.call(this);
        });
        ;
        $("#features-values-list .features-value-specific-list li").off("click");
        $("#features-values-list .features-value-specific-list li").on("click", function (e) {
            FeaturesFilterBar.clickFeatureValueEvent.call(this);
        });
        //remove selected items
        $(".feature-filter-item").removeClass("selectedWithItem");
        $(".feature-value-item").removeClass("selected");
        filter_manager_1.FilterManager.getCurrentFeaturesFilter();
        //set the component status
        FeaturesFilterBar.setStatus();
        //action icons
        $(FeaturesFilterBar.featureListIdSelector + " .feature-selected-delete").off("click");
        $(FeaturesFilterBar.featureListIdSelector + " .feature-selected-delete").on("click", function (e) {
            var id = $(this).parent().data("feature-id");
            var elementsToDisable = $("#" + "feature-values-list-" + id).children(".selected");
            FeaturesFilterBar.clickFeatureValueEvent.call(elementsToDisable);
            return false;
        });
        $(FeaturesFilterBar.featureListIdSelector + " .feature-selected-point").off("mouseenter");
        $(FeaturesFilterBar.featureListIdSelector + " .feature-selected-point").on("mouseenter", function () {
            $(this).siblings().show();
            $(this).hide();
        });
        $(FeaturesFilterBar.featureListIdSelector + " .feature-selected-delete").off("mouseleave");
        $(FeaturesFilterBar.featureListIdSelector + " .feature-selected-delete").on("mouseleave", function () {
            $(this).siblings().show();
            $(this).hide();
        });
        //remove selected items
        $(".feature-filter-item").removeClass("selectedWithItem");
        $(".feature-value-item").removeClass("selected");
        filter_manager_1.FilterManager.getCurrentFeaturesFilter();
        //set the component status
        FeaturesFilterBar.setStatus();
        // Reloading filter status.
        GenericFunctions.toggleFilterButton();
    };
    FeaturesFilterBar.clickFeatureEvent = function () {
        if (!$(this).hasClass("selected")) {
            var id = $(this).data("feature-id");
            $("#features-values-list .features-value-specific-list").hide();
            $(this).toggleClass("selected");
            if ($(this).hasClass("selected")) {
                $(this).siblings().removeClass("selected");
                $("#feature-values-list-" + id).show();
            }
            FeaturesFilterBar.LastExpandedFeatureFilter = id;
        }
    };
    FeaturesFilterBar.clickFeatureValueEvent = function () {
        var id = $(this).data("feature-value-id");
        var featureId = $(this).parent().data("parent-feature-id");
        $(this).toggleClass("selected");
        if ($(this).hasClass("selected")) {
            $("#feature-" + featureId).addClass("selectedWithItem");
        }
        else {
            if ($(this).siblings(".selected").length == 0) {
                $("#feature-" + featureId).removeClass("selectedWithItem");
            }
        }
        //update history with the selection
        filter_manager_1.FilterManager.setFeatures.apply(this);
    };
    FeaturesFilterBar.loadData = function (memberNr) {
        //current subcategory id
        var parsed = queryString.parse(location.search);
        var currentSubCategory = parsed.SubCategoryId;
        if (currentSubCategory == null) {
            $(FeaturesFilterBar.idSelector).html("");
            $(features_filter_bar_mobile_1.FeaturesFilterBarMobile.mobileFilterListIdSelector).html("");
            return;
        }
        $(FeaturesFilterBar.idSelector).addClass("loading-content");
        var promise = $.get({
            url: window.BaseUrlWithVersions + "/" + api_constants_1.ApiConstants.ProductSearchBase + "/" + categories_menu_1.CategoriesMenu.currentCategory + "/" + api_constants_1.ApiConstants.ProductSearchFilterBar + location.search,
        });
        promise.done(function (data) {
            var callBack = function () {
                $("#features-filter-bar-container").html(data);
                if ($("#bg-darken").length > 0 && $("#features-filter-modal-wrapper").is(":hidden") && $("#product-search-left-menu-wrapper").is(":hidden")) {
                    $("#features-filter-modal-wrapper").show().addClass("active-over");
                }
                if (FeaturesFilterBar.LastSubcategoryLoaded != subcategories_filter_bar_1.SubCategoriesFilterBar.CurrentSubcategory) {
                    FeaturesFilterBar.LastExpandedFeatureFilter = null;
                    FeaturesFilterBar.LastSubcategoryLoaded = subcategories_filter_bar_1.SubCategoriesFilterBar.CurrentSubcategory;
                }
                FeaturesFilterBar.init();
                features_filter_bar_mobile_1.FeaturesFilterBarMobile.init();
                brands_filter_bar_1.BrandsFilterBar.init();
            };
            GenericFunctions.ajaxResponseRedirectIfNeeded(data, callBack);
        });
        promise.fail(function () {
            $("#generic-error-modal #error-text").text(constants_1.Constants.ErrorGettingFeatures);
            $("#generic-error-modal").modal("show");
        });
        promise.always(function () {
            $(FeaturesFilterBar.idSelector).removeClass("loading-content");
        });
    };
    FeaturesFilterBar.isLoadNeeded = function () {
        var parsed = queryString.parse(location.search);
        var data = categories_menu_1.CategoriesMenu.currentCategory + "&" + parsed.Brands + "&" + parsed.MainProperties + "&" + parsed.SubCategoryId + "&" + parsed.Features;
        return data != FeaturesFilterBar.LastComponentStatus;
    };
    FeaturesFilterBar.setStatus = function () {
        var parsed = queryString.parse(location.search);
        var data = categories_menu_1.CategoriesMenu.currentCategory + "&" + parsed.Brands + "&" + parsed.MainProperties + "&" + parsed.SubCategoryId + "&" + parsed.Features;
        FeaturesFilterBar.LastComponentStatus = data;
    };
    FeaturesFilterBar.LastExpandedFeatureFilter = null;
    FeaturesFilterBar.featureListIdSelector = "#features-list";
    FeaturesFilterBar.idSelector = "#features-filter-bar";
    return FeaturesFilterBar;
}());
exports.FeaturesFilterBar = FeaturesFilterBar;
